<template>
  <Form
    v-model="modelFormData"
    class="form-email"
    :clear-on-destroy="clearOnDestroy"
    @clear="clear"
    @request="onSubmit"
  >
    <VInput
      label="Отправить на почту"
      name="email"
      email
      required
    >
      <Validation for="required">Это поле является обязательным</Validation>
      <Validation for="email">Введите адрес электронной почты</Validation>
    </VInput>

    <!-- TODO: если эта форма будет в другой форме, возможен преждевременный сабмит из-за этой кнопки   -->
    <AppButton
      title="Отправить по почте"
      type="blue"
      width="200px"
      :loading="isSending"
    />
  </Form>
</template>

<script>
import AppButton from '@/components/page/button/AppButton'
import Form from '@/components/page/Form/Form.vue'
import Validation from '@/components/page/Form/Validation'
import VInput from '@/components/page/Form/Vinput/Vinput'

import { MIXIN_FORM } from '@/mixins/form/mixinForm'

export default {
  name: 'FormEmail',
  components: {
    AppButton,
    Form,
    Validation,
    VInput
  },

  mixins: [MIXIN_FORM]
}
</script>
